import { PaymentItemType } from '../../enums/payment-item-type.enum';
import { PaymentStatus } from '../../enums/payment-status.enum';
import { PaymentModel } from '../../models/payment.model';

export enum ServiceFeeStatus {
  INCLUDED = 'included',
  WAIVED = 'waived'
}

/**
 * Whether the guest is charged a service fee on this reservation.
 *
 * Every payment carries a payment link, so "a link that charges a service fee" is a
 * payment with a utilities item: the service fee is the `utilities` line, whatever the
 * unit type named it. Cancelled payments no longer charge anything, and outgoing ones
 * (refunds, compensation) are money going back to the guest, so neither counts.
 *
 * Returns undefined when there is no payment left to judge by — a reservation nobody
 * has billed yet has not waived anything.
 */
export const getServiceFeeStatus = (payments?: PaymentModel[]): ServiceFeeStatus | undefined => {
  const chargeable = (payments || []).filter(
    (payment) => payment.status !== PaymentStatus.CANCELED && payment.direction !== 'out'
  );
  if (chargeable.length === 0) return undefined;

  const hasServiceFee = chargeable.some((payment) =>
    (payment.paymentItems || []).some((item) => item.itemType === PaymentItemType.utilities)
  );
  return hasServiceFee ? ServiceFeeStatus.INCLUDED : ServiceFeeStatus.WAIVED;
};
